import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import FaqTable from '../../components/faq/FaqTable'
import { fetchSectionQuestions, fetchQuestionsBySearch } from '../../actions/faq/faq'

export function mapStateToProps (state) {
  return {
    ...state.faq
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchSectionQuestions,
      fetchQuestionsBySearch
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(FaqTable))
